<div class="container">
  <mat-icon class="clear-icon" data-test="occurrences-dialog-clear" (click)="dialogRef.close()">clear</mat-icon>

  <sh-occurrences [chartData$]="data.chartData$" (pinGraph)="pinGraph()"></sh-occurrences>
</div>
